import { WebSdkService } from '../web-sdk/web-sdk.service';
import { AppSelectorService } from '../app-selector/app-selector.service';
import * as i0 from "@angular/core";
import * as i1 from "../web-sdk/web-sdk.service";
import * as i2 from "../app-selector/app-selector.service";
var FeatureSupportService = /** @class */ (function () {
    function FeatureSupportService(webSdkService, appSelectorService) {
        this.webSdkService = webSdkService;
        this.appSelectorService = appSelectorService;
        this.loading = true;
        this.setupSDK();
    }
    /**
     * setup feature enabling
     */
    FeatureSupportService.prototype.setupSDK = function () {
        var _this = this;
        this.webSdkService.getData('JSON', 'company-feature-list', {}).then(function (sdkData) {
            _this.companyFeatureList = sdkData;
            _this.companyDetails = _this.appSelectorService.getCompanyDetails();
        }).finally(function () {
            _this.loading = false;
            _this.checkfeatureList('segments');
        });
    };
    FeatureSupportService.prototype.checkfeatureList = function (feature) {
        var _this = this;
        var promise = new Promise(function (resolve) {
            _this.webSdkService.getData('JSON', 'company-feature-list', {}).then(function (sdkData) {
                _this.companyFeatureList = sdkData;
                _this.companyDetails = _this.appSelectorService.getCompanyDetails();
                if (_this.companyDetails.id && _this.companyDetails.id in _this.companyFeatureList) {
                    if (!_this.companyFeatureList[_this.companyDetails.id].includes(feature)) {
                        resolve(false);
                    }
                }
                resolve(true);
            });
        });
        return promise;
    };
    FeatureSupportService.ngInjectableDef = i0.defineInjectable({ factory: function FeatureSupportService_Factory() { return new FeatureSupportService(i0.inject(i1.WebSdkService), i0.inject(i2.AppSelectorService)); }, token: FeatureSupportService, providedIn: "root" });
    return FeatureSupportService;
}());
export { FeatureSupportService };
